import React from 'react';
import { useSelector } from 'react-redux';
import { Backdrop } from '@mui/material';
import { RootState } from '../../../api/store';
import { Loader } from './Loader';

export const LoaderOverlay: React.FC = () => {
  const { count, message } = useSelector((state: RootState) => state.loader);

  return (
    <Backdrop
      open={count > 0}
      sx={{
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Loader message={message} />
    </Backdrop>
  );
};

